export const connectionInfoWarnings = {
  login_pppoe_warn: ['Login', 'PPPOE'],
  login_ipoe_warn: ['Login', 'IPoE'],
  pwd_pppoe_warn: ['PWD', 'PPPOE'],
  pwd_ipoe_warn: ['PWD', 'IPoE'],
  speedInWarn: ['Speed In', ''],
  speedOutWarn: ['Speed Out', ''],
  ipWarn: ['IP', ''],
  routedSubnetWarn: ['Routed subnet', ''],
  vlanDgtekWarn: ['VLAN DGtek', ''],
  vlanRspWarn: ['VLAN RSP', '']
}
